

angular.module('trainerWebApp.services').factory('accountFeatures', [function() {
  var goodData;
  return {
    features: [],
    pricingType: null,
    advancedTierDaysLeft: null,
    trialDaysLeft: null,
    yammerEnabled: false,
    maxTeamMembers: 1,
    pricingMaxTrainees: 1,
    tierName: null,
    isUsernameEnabled: false,

    setGoodData: function (enabled, seriesReportUrlTemplate, traineesDashboardUrl, clientDashboardUrl) {
      goodData = {
        enabled: enabled,
        seriesReportUrlTemplate: seriesReportUrlTemplate,
        traineesDashboardUrl: traineesDashboardUrl,
        clientDashboardUrl: clientDashboardUrl
      };
    },

    getGoodData: function() {
      return goodData;
    }
  };
}]);
